import React, { useRef, useState } from 'react';
import { Button, ConfirmDialog } from '@ui';
import { translate } from '@utils/i18n';
import { convertProposalRequestProposalPath } from '@routes';
import { namespace } from '../ProposalShow/constants';
const csrfToken = () => { var _a; return ((_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || ''; };
/**
 * Convert action for a proposal request on the server-rendered pages (inspection, work order and
 * legacy proposal detail). Confirms in the shared dialog, then submits the conversion as a regular
 * form POST so the controller redirect and flash behave exactly as before.
 */
export default function ConvertProposalRequestAction({ proposalId, inspectionId, workOrderId, iconOnly = false }) {
    const formRef = useRef(null);
    const [isConfirming, setIsConfirming] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const label = translate('proposal_request.convert', { namespace });
    const handleConfirm = () => {
        var _a;
        setIsSubmitting(true);
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.submit();
    };
    return (React.createElement("form", { ref: formRef, method: "post", action: convertProposalRequestProposalPath(proposalId) },
        React.createElement("input", { type: "hidden", name: "authenticity_token", value: csrfToken() }),
        inspectionId && React.createElement("input", { type: "hidden", name: "inspection_id", value: inspectionId }),
        workOrderId && React.createElement("input", { type: "hidden", name: "work_order_id", value: workOrderId }),
        iconOnly ? (React.createElement("button", { type: "button", title: label, "aria-label": label, disabled: isSubmitting, onClick: () => setIsConfirming(true) },
            React.createElement("i", { className: "fa-light fa-file-import" }))) : (React.createElement(Button, { disabled: isSubmitting, onClick: () => setIsConfirming(true) }, label)),
        React.createElement(ConfirmDialog, { isOpen: isConfirming, title: translate('proposal_request.confirm_title', { namespace }), description: translate('proposal_request.confirm_body', { namespace }), confirmLabel: label, loading: isSubmitting, onConfirm: handleConfirm, onCancel: () => setIsConfirming(false) })));
}
